// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IReturnedCheckDto
 */
export interface IReturnedCheckDto {
    /**
     * 
     * @type {number}
     * @memberof IReturnedCheckDto
     */
    lockbox_id?: number;
    /**
     * 
     * @type {number}
     * @memberof IReturnedCheckDto
     */
    check_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IReturnedCheckDto
     */
    check_type?: IReturnedCheckDtoCheckTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IReturnedCheckDto
     */
    check_amount?: number;
    /**
     * 
     * @type {string}
     * @memberof IReturnedCheckDto
     */
    pay_to?: string;
}

/**
* @export
* @enum {string}
*/
export enum IReturnedCheckDtoCheckTypeEnum {
    LOCKBOX = 'LOCKBOX',
    PARTICIPANT = 'PARTICIPANT',
    PROVIDER = 'PROVIDER'
}


/**
 * Check if a given object implements the IReturnedCheckDto interface.
 */
export function instanceOfIReturnedCheckDto(value: object): value is IReturnedCheckDto {
    return true;
}

export function IReturnedCheckDtoFromJSON(json: any): IReturnedCheckDto {
    return IReturnedCheckDtoFromJSONTyped(json, false);
}

export function IReturnedCheckDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReturnedCheckDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lockbox_id': json['lockbox_id'] == null ? undefined : json['lockbox_id'],
        'check_id': json['check_id'] == null ? undefined : json['check_id'],
        'check_type': json['check_type'] == null ? undefined : json['check_type'],
        'check_amount': json['check_amount'] == null ? undefined : json['check_amount'],
        'pay_to': json['pay_to'] == null ? undefined : json['pay_to'],
    };
}

export function IReturnedCheckDtoToJSON(json: any): IReturnedCheckDto {
    return IReturnedCheckDtoToJSONTyped(json, false);
}

export function IReturnedCheckDtoToJSONTyped(value?: IReturnedCheckDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lockbox_id': value['lockbox_id'],
        'check_id': value['check_id'],
        'check_type': value['check_type'],
        'check_amount': value['check_amount'],
        'pay_to': value['pay_to'],
    };
}

